import { FunnelIcon } from '@heroicons/react/24/solid';
import React from 'react';

import type { DueFilter } from '../utils/crmDeepLinks';
import { DUE_FILTER_OPTIONS } from '../utils/crmDeepLinks';

interface DueFilterChipsProps {
  label: string;
  value: DueFilter;
  onChange: (value: DueFilter) => void;
}

function DueFilterChips({ label, value, onChange }: DueFilterChipsProps) {
  return (
    <div className="mb-4 flex items-center gap-3">
      <FunnelIcon className="h-4 w-4 text-gray-500" />
      <span className="text-sm font-medium text-gray-600">{label} :</span>
      <div className="flex gap-2">
        {DUE_FILTER_OPTIONS.map(option => (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            aria-pressed={value === option.value}
            className={`rounded-full px-4 py-1.5 text-sm font-medium transition-all duration-200 ${
              value === option.value
                ? 'bg-rgpd-blue text-white shadow-sm'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default DueFilterChips;
